import { Flex } from 'antd';
import { CircleFlag } from 'react-circle-flags';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { selectCountries } from 'store/countries';

export const PhoneCodeLabel = ({ countryCode }) => {
    const countries = useSelector(selectCountries);
    const country = countries.find(c => c.code === countryCode);
    if (!country) return null;
    
    return (
        <Flex align='center' gap={6}>
            <CircleFlag countryCode={countryCode.toLowerCase()} height="24" />
            <div>{country.phone_code}</div>
        </Flex>
    );
};

PhoneCodeLabel.propTypes = {
  countryCode: PropTypes.string.isRequired
};
